export default [



  {
    path: '/contents/list',
    name: 'contents-list',
    component: () => import('@/modules/contents/list/listContent.vue'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/contents/builder',
    name: 'contents-builder',
    component: () => import('@/modules/contents/add/contentBuilder'),
    // meta: {
    //   contentRenderer: 'sidebar-left',
    //   contentClass: 'email-application',
    // },
  },
  {
    path: '/contents/edit/:id',
    name: 'contents-edit',
    component: () => import('@/modules/contents/edit/editComponent'),

  },

  {
    path: '/contents/comments/:id',
    name: 'contents-comments',
    component: () => import('@/modules/contents/commentList/contentCommentList'),

  },

  {
    path: '/contents/arrange',
    name: 'contents-arrange',
    component: () => import('@/modules/contents/Arrage/arrangeContent'),

  },






]
